import { combineEpics } from 'redux-observable';
import { createDriverEpic } from './create-driver.epic';
import { fetchAllDriversEpic } from './fetch-all-drivers.epic';
import { fetchDriverByIdEpic } from './fetch-driver-by-id.epic';
import { updateDriverEpic } from './update-driver.epic';

export const combinedDriversEpics = combineEpics(fetchAllDriversEpic, fetchDriverByIdEpic, updateDriverEpic, createDriverEpic);
